import React from "react";
import Loading from "../../components/Loading/Loading";

const PayByMeFailedPage = () => {

  return (
    <Loading className="app-loading" fontSize={80}/>
  );
}

export default PayByMeFailedPage;
